// extracted by mini-css-extract-plugin
export default {"button":"SpecialtyProgButton_button__qc0IT"};